import { BrandAsset, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: ReactNode | string;
}

export const AuthHeading = (props: Props) => {
  const { title, subtitle } = props;

  return (
    <>
      <div
        className={css({
          display: "flex",
          justifyContent: "center",
        })}
      >
        <BrandAsset width={42} height={43.75} brand="certn" type="logo" />
      </div>
      <Text align="center" style="form/page-title-mobile">
        {title}
      </Text>
      {subtitle && (
        <Text align="center" style="form/body-primary">
          {subtitle}
        </Text>
      )}
    </>
  );
};
